import { render } from "./AssistanceList.vue?vue&type=template&id=fce31f4e&scoped=true"
import script from "./AssistanceList.vue?vue&type=script&lang=js"
export * from "./AssistanceList.vue?vue&type=script&lang=js"

import "./AssistanceList.vue?vue&type=style&index=0&id=fce31f4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce31f4e"]])

export default __exports__